import { Controller } from "stimulus"

export default class extends Controller {
  imageClicked(e) {
    e.currentTarget.classList.toggle('selected-photo')
  }
}